module.exports = __webpack_public_path__ + "static/media/BG_62.728222b2.png";